import React from 'react'
import { ZdsIcon } from '@zera/components'
import { Container, Avatar, LoaderMessage } from './styles'

export const Loader = (): JSX.Element => {
  return (
    <Container>
      <Avatar>
        <ZdsIcon src="MiMaleDoctor" />
      </Avatar>
      <LoaderMessage />
    </Container>
  )
}
